import { t } from "i18next";
import { UserResponseModel } from "shared/request/myHealthyAdvantageApi";

export const generatePrefilledText = (user?: UserResponseModel) => {
  if (!user) return t("support.whatsApp.prefilledText.intro");

  const dateOfBirth = user.dateOfBirth && Date.fromDateOnly(user.dateOfBirth)?.toLocaleDateString();
  const phoneNumber = user.phoneNumber && user.diallingCode ? `+${user.diallingCode.replace(/^\+/, "")}${user.phoneNumber}` : user.phoneNumber;

  const data = {
    firstName: `\n- ${t("support.whatsApp.prefilledText.firstname")} ${user.forenames}`,
    surname: `\n- ${t("support.whatsApp.prefilledText.surname")} ${user.surname}`,
    dateOfBirth: dateOfBirth ? `\n- ${t("support.whatsApp.prefilledText.dob")} ${dateOfBirth}` : "",
    gender: user.gender ? `\n- ${t("support.whatsApp.prefilledText.gender")} ${user.gender}` : "",
    phoneNumber: phoneNumber ? `\n- ${t("support.whatsApp.prefilledText.phone")} ${phoneNumber}` : "",
    email: user.email ? `\n- ${t("support.whatsApp.prefilledText.email")} ${user.email}` : "",
    code: user.client?.code ? `\n- ${t("support.whatsApp.prefilledText.code")} ${user.client?.code}` : "",
  };

  const message = `${t("support.whatsApp.prefilledText.intro")} ${t("support.whatsApp.prefilledText.details")}${data.firstName}${data.surname}${
    data.dateOfBirth
  }${data.gender}${data.phoneNumber}${data.email}${data.code}`;

  return encodeURIComponent(message);
};
